import { atom } from 'jotai'

export const selectedEmailAddressAtom = atom<string | null>(null)
